import { Pencil } from 'lucide-react'

import { EmailTemplate } from './constants'

type TemplateListItemProps = {
  template: EmailTemplate
  isSelected: boolean
  isEdited: boolean
  onClick: () => void
}

export const TemplateListItem = ({
  template,
  isSelected,
  isEdited,
  onClick,
}: TemplateListItemProps) => (
  <li>
    <button
      className={`flex w-full items-center justify-between rounded p-2 text-left ${
        isSelected ? 'bg-primary/10 text-primary' : 'hover:bg-gray-100'
      }`}
      onClick={onClick}
    >
      <span>{template.name}</span>
      {isEdited && <Pencil className="h-4 w-4" />}
    </button>
  </li>
)
